import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../content/Content";
import { AiOutlinePlusSquare } from "react-icons/ai";
import VideoPlayer from "./VideoPlayer";
import { useState } from "react";
const BroadCast = () => {
  const [playVideo, setPlay] = useState(false);
  return (
    <VStack
      w="100%"
      pb="40px"
      pt="30px"
      borderRadius="26px"
      bg={"rgba(255, 255, 255, 1)"}
      my="50px"
    >
      {/* top bar */}
      {/* desktop-version */}
      <Stack className="desktop-version" w="100%">
        <Stack
          flexDir="row"
          justifyContent="space-between"
          w="100%"
          px="50px"
          pb="30px"
        >
          <Box display="flex" alignItems="center">
            <Image src={Img.FeatureLogo} w="57px" h="49px" mx="10px" />
            <Text
              color="rgba(149, 151, 171, 1)"
              fontWeight="500"
              fontSize="20px"
            >
              FRX102- introductions ti trade overview
            </Text>
          </Box>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Image src={Img.people} mx="10px" />
            <Text mx="10px">Joined</Text>
            <Button
              bgColor="rgba(96, 31, 235, 1)"
              p={"3px 10px 3px 10px"}
              color="#fff"
              borderRadius="7px"
              mx="5px"
            >
              34
            </Button>
          </Box>
        </Stack>

        {/* video Player */}
        <Stack position={"relative"} w="100%"  h="100%">
          {playVideo ? (
            <Stack  w="100%" p="30px" position="relative" top="">
              <VideoPlayer />
            </Stack>
          ) : (
            <Stack position={"relative"} px="25px">
              <Image src={Img.VideoFeature} h="481px" w="100%" />
              {/* play icon */}
              <Box
                position={"absolute"}
                top={"0"}
                left={"0"}
                right={"0"}
                w="100%"
                height={"100%"}
                display="flex"
                flexDirection="column"
                justifyContent={"space-between"}
                alignItems="center"
              >
                <Stack
                  flexDir="row"
                  justifyContent="space-between"
                  w="100%"
                  py="40px"
                  px="25px"
                  h="33%"
                >
                  <Image src={Img.FeatureLogo} w="57px" h="49px" mx="10px" />
                  <Box
                    bg="rgba(255, 255, 255, 0.28)"
                    borderRadius="11px"
                    p="11px 12px 11px 12px"
                    display="flex"
                    flexDirection="row"
                    justifyContent={"flex-start"}
                    alignItems="center"
                    me="25px"
                  >
                    <Image src={Img.avatarL} h="49px" w="49px" />
                    <Text
                      mx="10px"
                      color="rgba(255, 255, 255, 1)"
                      fontSize="20px"
                      fontWeight="600"
                    >
                      JC Morales
                      <Text
                        color="rgba(214, 214, 214, 1)"
                        fontSize="20px"
                        fontWeight="400"
                      >
                        FFX Educators
                      </Text>
                    </Text>
                  </Box>
                </Stack>
                <Stack
                  flexDir="row"
                  justifyContent="space-between"
                  w="100%"
                  py="40px"
                  px="25px"
                  h="33%"
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent={"center"}
                    alignItems="center"
                    w="100%"
                  >
                    <Button onClick={() => setPlay(!playVideo)} bg="transparent" _hover={{bg:"transparent"}}>
                      <Image src={Img.play} h="81px" w="81px" />
                    </Button>
                  </Box>
                </Stack>

                <Stack
                  flexDir="row"
                  justifyContent="space-between"
                  alignItems={"center"}
                  w="100%"
                  py="40px"
                  px="25px"
                  h="33%"
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent={"flex-start"}
                    alignItems="center"
                    me="25px"
                  >
                    <Button
                      bg="rgba(255, 255, 255, 0.28)"
                      borderRadius="11px"
                      p="11px 12px 11px 12px"
                      display="flex"
                      flexDirection="row"
                      justifyContent={"flex-start"}
                      alignItems="center"
                    >
                      <Image src={Img.record} h="19px" w="19px" />
                      <Text
                        mx="10px"
                        color="rgba(255, 255, 255, 1)"
                        fontSize="20px"
                        fontWeight="400"
                      >
                        52:34
                      </Text>
                    </Button>
                    <Button
                      bg="rgba(255, 255, 255, 0.28)"
                      borderRadius="11px"
                      w="50px"
                      h="50px"
                      display="flex"
                      flexDirection="row"
                      justifyContent={"center"}
                      alignItems="center"
                      marginX="10px"
                      p={"10px"}
                    >
                      <Image src={Img.refresh} h="20px" w="20px" />
                    </Button>
                  </Box>
                  <Box
                    bg="rgba(255, 255, 255, 0.28)"
                    borderRadius="5px"
                    display="flex"
                    flexDirection="row"
                    justifyContent={"flex-start"}
                    alignItems="center"
                    me="25px"
                    h="37px"
                    px="10px"
                  >
                    <Text
                      color="rgba(0, 0, 0, 1)"
                      fontSize="14px"
                      fontWeight="400"
                    >
                      Live channel might be 3 miniuts / refresh the page
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </Stack>
          )}
        </Stack>
      </Stack>

      {/* mobile-version */}
      <Stack className="mobile-version">
        <Stack flexDir="row" justifyContent="space-between" w="100%" pb="30px">
          <Box display="flex" alignItems="center">
            <Image src={Img.FeatureLogo} w="57px" h="49px" mx="10px" />
            <Text
              color="rgba(149, 151, 171, 1)"
              fontWeight="500"
              fontSize="14px"
              wordBreak="break-word"
              pr="19px"
            >
              FRX102- introductions ti trade overview
            </Text>
          </Box>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Image src={Img.people} mx="10px" />
            <Button
              bgColor="transparent"
              p={"3px"}
              color="rgba(149, 151, 171, 1)"
              borderRadius="7px"
              mx=""
              fontSize="18px"
            >
              34
            </Button>
            <Button
              bgColor="transparent"
              p={"0"}
              color="rgba(149, 151, 171, 1)"
              borderRadius="7px"
              mx="0"
              fontSize="18px"
            >
              <AiOutlinePlusSquare />
            </Button>
          </Box>
        </Stack>

        {/* video Player */}
          {playVideo ?       
          <Stack  w="100%" p="30px" position="relative" top="">
              <VideoPlayer />
          </Stack> :
        <Stack position={"relative"}>
        <Image src={Img.VideoFeature} h="201px" w="100%" />
        {/* play icon */}
        <Box
          position={"absolute"}
          top={"0"}
          left={"0"}
          right={"0"}
          w="100%"
          height={"100%"}
          display="flex"
          flexDirection="column"
          justifyContent={"space-between"}
          alignItems="center"
        >
          <Stack
            flexDir="row"
            justifyContent="end"
            w="100%"
            py="40px"
            px="25px"
            h="33%"
          >
            <Box
              bg="rgba(255, 255, 255, 0.28)"
              borderRadius="11px"
              display="flex"
              flexDirection="row"
              justifyContent={"flex-start"}
              alignItems="center"
              me="5px"
            >
              <Image src={Img.avatarL} h="33px" w="33px" />
              <Text
                mx="10px"
                color="rgba(255, 255, 255, 1)"
                fontSize="20px"
                fontWeight="600"
              >
                JC Morales
                <Text
                  color="rgba(214, 214, 214, 1)"
                  fontSize="20px"
                  fontWeight="400"
                >
                  FFX Educators
                </Text>
              </Text>
            </Box>
          </Stack>
          <Stack
            flexDir="row"
            justifyContent="space-between"
            w="100%"
            py="40px"
            px="25px"
            h="33%"
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent={"center"}
              alignItems="center"
              w="100%"
            >
              <Button
                bg="transparent"
                p="0"
                m="0"
                border="0"
                _hover={{ bg: "transparent" }}
                onClick={() => setPlay(!playVideo)}
              >
                <Image src={Img.play} h="51px" w="51px" />
              </Button>
            </Box>
          </Stack>

          <Stack
            flexDir="row"
            justifyContent="space-between"
            alignItems={"center"}
            w="100%"
            py="40px"
            px="25px"
            h="33%"
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent={"flex-start"}
              alignItems="center"
              me="25px"
            >
              <Button
                bg="rgba(255, 255, 255, 0.28)"
                borderRadius="11px"
                h="29px"
                w="90px"
                display="flex"
                flexDirection="row"
                justifyContent={"flex-start"}
                alignItems="center"
                position={"relative"}
                top="-30px"
              >
                <Image src={Img.record} h="15px" w="15px" />
                <Text
                  mx="10px"
                  color="rgba(255, 255, 255, 1)"
                  fontSize="12px"
                  fontWeight="400"
                >
                  52:34
                </Text>
              </Button>
            </Box>
          </Stack>
        </Box>
      </Stack>

          }


      </Stack>
    </VStack>
  );
};

export default BroadCast;
